// Project.jsx
import React from "react";

const projects = [
  // Mini / Learning Projects
  { id: 1, title: "Calculator", description: "Simple frontend project.", link: "https://muhammad-abdullah-coder.github.io/Calculator_Frontend/", type: "Mini Project" },
  { id: 2, title: "Registration Form", description: "Simple frontend project.", link: "https://muhammad-abdullah-coder.github.io/Registration_page/", type: "Mini Project" },
  { id: 3, title: "Countdown Timer", description: "Simple frontend project.", link: "https://muhammad-abdullah-coder.github.io/CountdownTimer/", type: "Mini Project" },
  { id: 4, title: "Canada Imigration Website", description: "Simple frontend project.", link: "https://muhammad-abdullah-coder.github.io/Canada_imigration_website/", type: "Mini Project" },
  { id: 5, title: "Todo List", description: "Simple frontend project.", link: "https://muhammad-abdullah-coder.github.io/Todo_list/", type: "Mini Project" },

  // Portfolio Projects
  { id: 6, title: "Student Management System - Frontend", description: "Frontend version for practice.", link: "https://muhammad-abdullah-coder.github.io/Student_Management_System_Frontend/", type: "Portfolio Project" },
  { id: 7, title: "Student Management System - Backend", description: "Backend version built with Django.", link: "https://github.com/Muhammad-Abdullah-Coder/Student_Management_System_Backend", type: "Portfolio Project" },
  { id: 8, title: "DevArticles Website", description: "Backend project built with Django.", link: "https://github.com/Muhammad-Abdullah-Coder/DevArticles", type: "Portfolio Project" },
  { id: 9, title: "Portfolio Website", description: "Personal portfolio built with React and Django.", link: "https://github.com/Muhammad-Abdullah-Coder/Abdullah_Portfolio", type: "Portfolio Project" },
  { id: 10, title: "Safarnama Website", description: "Frontend project built for practice.", link: "https://safarnama-indol.vercel.app", type: "Portfolio Project" },
  { id: 11, title: "Delicious restaurant", description: "Frontend project built for practice.", link: "https://delicious--restaurant.web.app", type: "Portfolio Project" },
  { id: 12, title: "Bali Beauty Haven",   description: "Modern responsive beauty salon website.", link: "https://bali-beauty-haven.web.app/", type: "Portfolio Project" },
  { id: 13, title: "Appliance Repair Services",   description: "Professional home appliance service website.",   link: "https://appliance-repair-services.web.app/",   type: "Portfolio Project" },
  { id: 14, title: "Mrdevworks", description: "Current live website.", type: "Portfolio Project" },

  // Client Project
  { id: 15, title: "Slice & Spice Website", description: "Backend website built for Fiverr client.", link: "https://drive.google.com/file/d/1s9HDzL8fdxTdZKVqkX70e7WaTJxwBUS-/view?usp=drive_link", type: "Client Project" },
];

const Project = () => {
  return (
    <section id="projects" className="py-5" style={{ background: "linear-gradient(to right, #0f2027, #203a43, #2c5364)"}}>
      <div className="container">
        <div className="text-center mb-5 text-white">
          <h2 className="fw-bold">My Projects</h2>
          <div
            className="mx-auto"
            style={{
              width: "80px",
              height: "3px",
              background: "linear-gradient(135deg, #ff4e50, #f9d423)",
              borderRadius: "2px",
            }}
          ></div>
        </div>

        <div className="row">
          {projects.map((project) => (
            <div key={project.id} className="col-md-6 mb-4">
              <div
                className="p-4 rounded-4 text-white project-card"
                style={{
                  background: "#162447",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
                  transition: "transform 0.3s, box-shadow 0.3s",
                }}
              >
                <h4 className="fw-semibold mb-2 text-white">{project.title}</h4>
                <p className="text-light mb-2">{project.description}</p>
                <span
                  className={`badge ${
                    project.type === "Client Project"
                      ? "bg-warning text-dark"
                      : project.type === "Mini Project"
                      ? "bg-secondary text-white"
                      : "bg-info text-dark"
                  }`}
                >
                  {project.type}
                </span>
                <br />
                {project.link && (
                  <a
                    href={project.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-warning fw-bold mt-2 d-inline-block"
                  >
                    View Project
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Inline CSS for hover effect */}
      <style>
        {`
          .project-card:hover {
            transform: translateY(-10px);
            box-shadow: 0 20px 40px rgba(255, 78, 80, 0.5);
          }
        `}
      </style>
    </section>
  );
};

export default Project;
